import * as React from 'react';
import {Component, CSSProperties, ReactNode} from 'react';
import * as classNames from 'classnames';
import * as _ from 'lodash';

import {INewsItem} from '../../../components/biz/newsItem/model';
import NewsItem from '../../../components/biz/newsItem';
import {L} from '../../../lang';
import Advertising from '../../advertising/component/index';

if (process.env.BROWSER) {
  require('./index.less');
}

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
  hasMore?: boolean;
  isLoading: boolean;
  isShowLoadMoreComponent: boolean;
  newsList: INewsItem[];
  pageSize: number;
  currentPage: number;
  getNewsList?: () => Promise<void>;
  onLoadMore?: () => void;
  onShowNewsList?: () => void;
  onClickNewsItem?: (news: INewsItem) => void;
  exposurePromise: Promise<any>;
  adSlotId?: string;
  config?: any;
  scriptSrc?: any;
}
interface IComponentState {
  ready?;
}

export default class ArticleNewsList extends Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {};
    [
      'getDomNewsList',
      'getDomLoadMore',
      'handleLoadMore',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
  }

  public async componentDidMount(): Promise<void> {
    const getList = this.props.getNewsList();
    Promise.all([getList, this.props.exposurePromise]).then(() => {
      this.props.onShowNewsList();
    });
  }

  public render(): ReactNode {
    const classesRoot: string = classNames('newsList-wrapper', this.props.className);
    const domDivider: ReactNode = this.getDomTitleDivider();
    const domNewsList: ReactNode = this.getDomNewsList();
    const domLoadMore: ReactNode = this.getDomLoadMore();
    return (
      <div className={classesRoot} style={this.props.style}>
        { domDivider }
        { domNewsList }
        { domLoadMore }
      </div>
    );
  }

  public getDomTitleDivider(): ReactNode {
    if (this.props.newsList === undefined || this.props.newsList === null) { return null; }
    if (this.props.newsList.length === 0) { return null; }
    return (
      <div className={'newsList-header-divider'}>
        <div className={'divider-inner-text'}>{L('default.related_news')}</div>
      </div>
    );
  }

  public getDomNewsList(): ReactNode {
    let domNewsList: ReactNode = null;
    if (this.props.newsList === undefined || this.props.newsList === null) { return domNewsList; }
    if (this.props.newsList.length === 0) { return domNewsList; }
    const limitedIndex: number = this.props.pageSize * (this.props.currentPage + 1);
    const renderNews: INewsItem[] = _.filter(this.props.newsList, (newsItem: INewsItem, index: number) => {
      return index < limitedIndex;
    });
    domNewsList = (
      <div className={'newsList-list-wrapper'}>
        {this.getNewsListFromDataWithAd(renderNews)}
      </div>
    );
    return domNewsList;
  }

  public getNewsListFromDataWithAd(renderNews: INewsItem[]): ReactNode[] {
    const r = [];
    const { config, scriptSrc } = this.props;
    for (let i = 0; i < renderNews.length; i++) {
      const newsItem = renderNews[i];

      const item = <NewsItem key={newsItem.id}
                             news={newsItem}
                             styleType={newsItem.style as any}
                             onClick={() => {
                               this.props.onClickNewsItem(newsItem);
                             }}
      />;
      r.push(item);
      if (config && config.newsList && config.newsList.newsListResult.length > 0) {
        config.newsList.newsListResult.map((listItem, listIndex) => {
          if (listItem.position === i) {
            listItem.chance = config.newsList.chance;
            const newsItemConfig = Object.assign({}, config, {newsList: listItem});
            r.push(<Advertising key={listItem.adSlot + '-' + listIndex} isFluid={true} type="newsList" config={newsItemConfig} scriptSrc={scriptSrc}/>);
          }
        });
      }
      // if (i === 4 && this.props.config) {
      //   r.push(<Advertising type="newsList" config={this.props.config} scriptSrc={this.props.scriptSrc}/>);
      // }
    }
    return r;
  }

  public getDomLoadMore(): ReactNode {
    if (this.props.isShowLoadMoreComponent === false) { return null; }
    let domLoadMoreContent: ReactNode = (
      <div className={'loadMore-content'}>
        <span className="click-able">{L('default.more')}</span>
      </div>
    );
    if (this.props.hasMore === false) {
      if (this.props.currentPage === 0) {
        domLoadMoreContent = null;
      } else {
        domLoadMoreContent = (
          <div className={'loadMore-content'}>
            <span>{L('default.no_more')}</span>
          </div>
        );
      }
    }
    return (
      <div className={'loadMore-wrapper'} onClick={ this.handleLoadMore }>
        { domLoadMoreContent }
      </div>
    );
  }

  public handleLoadMore(): void {
    if (this.props.isShowLoadMoreComponent === false) { return ; }
    if (this.props.hasMore === false) { return ; }
    if (this.props.onLoadMore) {
      this.props.onLoadMore();
    }
  }
}
